import request from '#/utils/request';
import { hydrateJsonBlobError } from '#/utils/blobResponseError';

function parseFilenameFromContentDisposition(header) {
  if (!header || typeof header !== 'string') {
    return null;
  }

  const utf8Match = /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ''));
    } catch {
      return utf8Match[1].trim().replace(/^"|"$/g, '');
    }
  }

  const plainMatch = /filename="?([^";]+)"?/i.exec(header);
  return plainMatch?.[1]?.trim() || null;
}

/**
 * 下載 BOM Excel（xlsx Blob）。
 * @returns {Promise<{ blob: Blob, filename: string }>}
 */
export async function downloadBomExcel(id) {
  try {
    const response = await request.get(`/mom/bom/${id}/excel`, {
      responseType: 'blob',
    });

    const disposition = response.headers?.['content-disposition']
      ?? response.headers?.['Content-Disposition'];
    const filename = parseFilenameFromContentDisposition(disposition) || 'bom.xlsx';

    return {
      blob: response.data,
      filename,
    };
  } catch (error) {
    await hydrateJsonBlobError(error);
    throw error;
  }
}
